import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {v4 as uuid} from 'uuid';

import {filterCatalog, buildCatalogTree, buildCatalogMap, getFriendlyCatalogPathName} from '../../lib/catalog';
import Input from '../Input';
import Card from '../Card';
import Popover from '../Popover';
import Button from '../Button';

class CatalogInput extends PureComponent {
  id = uuid();
  state = {
    showCatalog: false,
    search: ""
  };

  handleFocus = () => {
    this.setState({showCatalog: true});
  }

  handleBlur = () => {
    this.setState({showCatalog: false, search: ""});
  }

  handleChange = itemId => {
    const {value, onChange, multiple} = this.props;
    
    if (multiple) {
      if (value.indexOf(itemId) >= 0) {
        onChange(value.filter(v => v !== itemId));
      }
      else {
        onChange([...value, itemId]);
      }
    }
    else {
      this.handleBlur();
      onChange(itemId);
    }
  }

  getId() {
    return this.props.id ? this.props.id : this.id;
  }

  render() {
    const {catalog, value, multiple, ...inputProps} = this.props;
    const {showCatalog, search} = this.state;
    const catalogById = buildCatalogMap(catalog);
    const matching = filterCatalog(search, catalogById);
    const tree = buildCatalogTree(matching);
    let friendlyValue = '';

    if (multiple && !Array.isArray(value)) {
      throw new Error('The multiple variant of CatalogInput must have an array value');
    }

    if (multiple) {
      friendlyValue = value
        .map(id => catalogById[id.trim()])
        .filter(item => !!item)
        .map(item => item.name)
        .join(', ');
    }
    else if (value) {
      friendlyValue = getFriendlyCatalogPathName(catalogById[value.trim()], catalogById);
    }

    return (
      <>
        <Input
          {...inputProps}
          readOnly
          id={this.getId()}
          type="text"
          value={friendlyValue}
          onFocus={this.handleFocus}
        />
        <Popover fullWidth open={showCatalog} relativeTo={this.getId()} onClose={this.handleBlur}>
          <Input type={"text"} placeholder={"Search catalog"} value={search} onChange={e => this.setState({search: e.target.value})}/>
          <CatalogContainer>
            <CatalogTree multiple={multiple} tree={tree} value={value} onSelect={this.handleChange} />
          </CatalogContainer>
        </Popover>
      </>
    );
  }
}

function CatalogTree({multiple, tree, value, onSelect}) {
  if (tree.length < 1) {
    return null;
  }

  return (
    <ul>
      {tree.map(branch => (
        <li key={branch.id}>
          <Button
            tertiary
            block
            center={false}
            active={multiple ? value.indexOf(branch.id) >= 0 : value === branch.id}
            onClick={() => onSelect(branch.id)}>
            {branch.name}
          </Button>
          <CatalogTree multiple={multiple} tree={branch.children} value={value} onSelect={onSelect} />
        </li>
      ))}
    </ul>
  );
}

const CatalogContainer = styled(Card)`
  height: 12rem;
  overflow: auto;

  ul, li {
    position: relative;
  }

  ul {
    list-style: none;
    padding-left: 2rem;
  }

  li::before, li::after {
    content: "";
    position: absolute;
    left: -1rem;
  }

  li::before {
    border-top: 1px solid #b4b4b4;
    top: 1rem;
    width: 1rem;
    height: 0;
  }

  li::after {
    border-left: 1px solid #b4b4b4;
    height: 100%;
    width: 0px;
    top: 0px;
  }

  ul > li:last-child::after {
    height: 1rem;
  }
`;

export default CatalogInput;